import { matchPath } from 'react-router';

import { getUserRoutes } from './helpers';

export const userHasAccess = (user: any, route: string) => {
  return getUserRoutes(user).some((path) => matchPath({ path }, route));
};

export const filterRoutes = (
  user: any,
  routes: { link: string; dataCy: string; label: string }[],
) => {
  const userRoutes = getUserRoutes(user);
  return routes.filter(({ link }) => userRoutes.includes(link));
};
